

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-sidebar-installment-options.route', ['squid', 'hermes.page.xo-sidebar-installment-options.directive']).factory('$SidebarInstallmentOptionsRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('InstallmentOptionsRoute', {
            name: 'installmentOptions',
            directive: 'xo-sidebar-installment-options-page',

            // Uncomment the following line to suffix content to
            // the title of the page
            // Base title is 'PayPal Checkout'
            // titleContent: 'accountCreationGuest.heading',

            trackingData: {
                templateName: 'tray/installmentOptions.dust',
                pageGoal: 'Installment Options',
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-installment-options',
                        'pagename2': '%::fullpage-installment-options::hermes:',
                        'version': ':%:'
                    }
                }
            },
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-installment-options/route.js
// module id = ./pages/xo-sidebar-installment-options/route.js
// module chunks = 0